document.addEventListener("DOMContentLoaded", () => {

    // JS FOR VIEW ALL BUTTON

    const observer = new MutationObserver(function (mutations) {
        const boostSDRecommendation = document.querySelector('.boost-sd__recommendation');
        if (boostSDRecommendation) {
            observer.disconnect();

            // Get the button container and boost slider
            const buttonContainer = document.querySelector('.boost__view-all-button');
            const boostSliderContainer = boostSDRecommendation.querySelector('.boost-sd__slider-container .slick-dots');
            if (buttonContainer && boostSliderContainer) {
                document.querySelector('.shopify-section:has(.boost-sd__recommendation) > .page-width')?.classList.add('custom-scroll')
                buttonContainer.style.display = 'block';
                // Append the button to the slider container

                boostSliderContainer.before(buttonContainer);
                buttonContainer.style.display = 'block'; // Ensure the button is visible

            }
        }
    });

    // Start observing the document with the configured parameters
    observer.observe(document, { attributes: false, childList: true, characterData: false, subtree: true });

});
